import React from 'react';
import { Link } from 'react-router-dom';
import { SectionContainer } from '../pages/shared.styled';
import gsaStarMark from '../assets/gsa-seal.png';
import { TERMS_OF_USE_URL } from '../utlities/core.constants';


export default function Footer() {
  return (
    <footer className='bg-primary-darker text-white'>
      <SectionContainer>
        <div className='flex mb-4'>
          <div>
            <span className='inline-block h-14 w-14'>
              <img src={gsaStarMark} alt="Seal of the General Services Administration" style={{ height: '56px', width: '56px', objectFit: 'contain' }} />
            </span>
          </div>
          <div className='pl-4 flex flex-col justify-evenly'>
            <div>acr-repository.section508.gov</div>
            <div className='text-bold'>An official website of the <a href="https://www.gsa.gov/">General Services Administration</a></div>
          </div>
        </div>
        <div className='text-lg grid grid-cols-4 gap-y-2 mb-6'>
          <span><a href="https://www.gsa.gov/about-us">About GSA</a></span>
          <span><a href="https://www.gsa.gov/reference/freedom-of-information-act-foia">FOIA requests</a></span>
          <span><a href="https://www.gsaig.gov/">Office of the Inspector General</a></span>
          <span><a href="https://www.gsa.gov/website-information/website-policies">Privacy policy</a></span>
          <span><a href="https://www.gsa.gov/website-information/accessibility-statement">Accessibility statement</a></span>
          <span><a href="https://www.gsa.gov/reference/civil-rights-programs/notification-and-federal-employee-antidiscrimination-and-retaliation-act-of-2002">No FEAR Act data</a></span>
          <span><a href="https://www.gsa.gov/reference/reports/budget-performance">Performance reports</a></span>
          <span><a href="https://www.section508.gov/website-policies/#reuse-and-copyright">Reuse and Copyright</a></span>
          <span><Link to={TERMS_OF_USE_URL}>Terms of Use</Link></span>
        </div>
        <div>
          Looking for U.S. government information and services? <span className='font-bold'><a href="https://www.usa.gov/">Visit USA.gov</a></span>
        </div>
      </SectionContainer>
    </footer>
  )
}
